import { useContext } from 'react';
import { LangSwitch, Base, t } from 'zf-web-components';
import { Icons } from 'zf-web-components/icons';
import { RootContext } from '@stores';
import { useApp } from '@components';
import { Collapse } from './collapse';
import styles from './style.module.less';
import { useLogout } from './hooks';
import { ToolsMenu } from './tools';
import { SearchCenter, useSearchCenter } from './searchCenter';
import type { LanguageProps } from 'zf-web-components';
import type { ReactElement } from 'react';

export function Header(): ReactElement | null {
  const rootContext = useContext(RootContext);
  const { onLogout } = useLogout();
  const { app, colorPrimary: backgroundColor } = useApp();
  const { canRender, LazySearchCenter } = useSearchCenter(app);

  // 固定不显示菜单和头部
  if (rootContext.getIsHideMenuAndHeader()) {
    return null;
  }

  return (
    <Base.Layout.Header style={{ backgroundColor }} className={styles.header} itemType='vert'>
      <Collapse />
      <Base.Space className={styles.toolsItem} split={<Base.Divider type='vertical' className={styles.headerMenu} />}>
        {canRender && LazySearchCenter != null && <SearchCenter LazySearchCenter={LazySearchCenter} />}
        <ToolsMenu />
        <LangSwitch onChange={key => rootContext.local.lang = key} lang={rootContext.local.lang as LanguageProps['lang']} />
        <Base.Space className={styles.toolsItem} onClick={() => {
          onLogout();
        }}>
          <Icons name='LogoutOutlined' />
          <span className={styles.headerText}>
            {t('退出')}
          </span>
        </Base.Space>
      </Base.Space>
    </Base.Layout.Header>
  );
}
